import React from 'react';
import Chip from '@material-ui/core/Chip';

function SearchChipEmpty({ ...props }) {
  return <Chip variant="outlined" color="default" {...props} />;
}

export default SearchChipEmpty;
